import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import SearchPanel from "@widgets/SearchPanel";
import { fnGetDataSet, fnSave } from "@shared/api/restApi";
import { getInitPopUpData } from "@shared/utils/CommonUtils";
import { global } from "@shared/libs/Global";
//import SnGrid from "@shared/components/Grid/SnGrid";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnSearchBtn from "@shared/components/SnSearchBtn";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnNumberBox from "@shared/components/SnNumberBox";
import SnLabel from "@shared/components/SnLabel";
import { SnButton } from "@shared/components/SnButton";
import { showDialog } from "@widgets/CommonDialog";
import { CellValueChangedEvent } from "@shared/components/GridV2/SnGridTypes";

interface popupProps {
  selectedDataList?: any;
  rowDataList?: any;
  modalRef?: any;
}

interface RowData {
  KeyField?: string; // 행의 고유 ID
  [key: string]: any;
}

const SN_QMS_CHEM_REG_001_POP_01 = forwardRef(
  ({ selectedDataList, modalRef }: popupProps, ref: React.Ref<any>) => {
    //#region variable
    const { userInfo } = global();
    const searchRef = useRef<any>(null);
    //#endregion

    const [qt_qc_bad, setQtQcBad] = useState<number>(0);
    const [qt_qc_rcl, setQtQcRcl] = useState<number>(0);
    //#region Components useState
    const [formData, setFormData] = useState<any>();
    const [formControlData, setFormControlData] = useState<any[]>([]);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
    });
    const [columns, setColums] = useState<any>({
      grid1: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
    });
    const [doubleData, setDoubleData] = useState<any[]>();
    const [popupParent, setPopupParent] = useState<any>(null);
    //#endregion

    useImperativeHandle(ref, () => ({
      getSelectedValue: () => {
        onSave();
      },
      getSelectedRow: () => [gridRefs.current["grid1"].current?.getChange()],
    }));

    useEffect(() => {
      if (doubleData) {
        modalRef.current?.handleConfirm(true);
      }
    }, [doubleData]);

    useEffect(() => {
      if (modalRef?.current) {
        setPopupParent(modalRef.current.getPopupParent());
      }
    }, [modalRef?.current]);

    useEffect(() => {
      const fetchform = async () => {
        try {
          // 세목판정 팝업 메타는 SN_QMS_REQ_REG_002_POP_01 것을 그대로 재사용한다.
          // (SN_QMS_CHEM_REG_001_POP_01 메타가 아직 등록되어 있지 않아 빈 팝업이 떴음)
          const rtn: any = await getInitPopUpData(
            "SN_QMS_REQ_REG_002_POP_01",
            {}
          );

          setFormControlData(rtn.formControlData); // 조회조건 항목 설정
          const newFormData = {
            cd_item: selectedDataList.cd_item,
            nm_item: selectedDataList.nm_item,
            dc_item_spec: selectedDataList.dc_item_spec ?? " ",
            dc_item_unit: selectedDataList.dc_item_unit ?? " ",
            no_lot: selectedDataList.no_lot,
            cd_firm: selectedDataList.cd_firm,
          };

          setFormData(newFormData);
          setColums({
            grid1: rtn.grid.grid1,
          });
          await onSearch();
        } catch (error) {}
      };
      fetchform();
    }, [userInfo]);

    //#region Button Event
    const onSearch = async () => {
      const fetchdatasource = async () => {
        try {
          const params = {
            id: "sn_qms_req_reg_002_pop_01",
            params: selectedDataList,
          };

          const data: any = await fnGetDataSet(params);
          const rows = data?.[0] ?? [];
          setDataSources({
            grid1: rows,
          });
          let qt_qc_good = 0,
            qt_qc_bad = 0,
            qt_qc_rcl = 0;
          rows.forEach((row: any) => {
            qt_qc_good += row.qt_qc_good;
            qt_qc_bad += row.qt_qc_bad;
            qt_qc_rcl += row.qt_qc_rcl;
          });
          setQtQcBad(qt_qc_bad);
          setQtQcRcl(qt_qc_rcl);
          gridRefs.current["grid1"].current.selectAndFocusRow(0);
          gridRefs.current["grid1"].current.resetUpdate();
        } catch (error) {
          console.log(error);
        }
      };
      await fetchdatasource();
    };
    const onSave = async () => {
      gridRefs.current["grid1"].current?.stopEditing();
      const grid = gridRefs.current["grid1"].current?.getChange();
      if (grid.modifiedRowcount < 1) {
        showDialog("alter", "변경된 내용이 없습니다.");
        return;
      }
      const saveData = {
        req: grid,
      };
      await fnSave("SN_QMS_REQ_REG_002_SAVE_01", saveData);
    };
    const onFocusedRowChanged = async (event: any) => {
      const selectedRow = event;
    };
    const onCellValueChangedH = async (event: CellValueChangedEvent) => {
      const rowData = event.rowData;
      const colId = event.colId;
      const focusedNodeH = gridRefs.current["grid1"].current.focusedRowNode();
      if (colId === "qt_qc_bad") {
        focusedNodeH.setDataValue(
          "qt_qc_good",
          focusedNodeH.data.qt_req - rowData.qt_qc_bad,
          "noEvent"
        );
        focusedNodeH.setDataValue(
          "qt_qc_rcl",
          focusedNodeH.data.qt_req - rowData.qt_qc_bad,
          "noEvent"
        );
        focusedNodeH.setDataValue("qt_qc", focusedNodeH.data.qt_req, "noEvent");
      } else if (colId === "qt_qc_rcl") {
        focusedNodeH.setDataValue(
          "qt_qc_bad",
          focusedNodeH.data.qt_req - rowData.qt_qc_rcl,
          "noEvent"
        );
        focusedNodeH.setDataValue("qt_qc_good", rowData.qt_qc_rcl, "noEvent");
        focusedNodeH.setDataValue("qt_qc", focusedNodeH.data.qt_req, "noEvent");
      }
    };
    const onAfterSetFooter = () => {
      const footerData = gridRefs.current["grid1"].current.getFooterData();
      setQtQcBad(footerData.qt_qc_bad);
      setQtQcRcl(footerData.qt_qc_rcl);
    };
    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onFocusedRowChanged: onFocusedRowChanged,
            onCellValueChanged: onCellValueChangedH,
            onAfterSetFooter: onAfterSetFooter,
          },
        },
      }),
      [columns, dataSources]
    );

    return (
      <div className="h-full flex flex-col">
        <div>
          <SearchPanel
            ref={searchRef}
            data={formData}
            controls={formControlData}
            popupRef={ref}
          />
        </div>
        <div
          style={{
            display: "flex",
            width: "90%",
            alignItems: "center",
            gap: "10px",
            margin: "10px 0px 0px 0px",
          }}
        >
          <SnLabel text={"불량수량"} type={"FreeForm"} />
          <SnNumberBox
            defaultValue={qt_qc_bad}
            format="####,####"
            isRequired={true}
            isReadOnly={true}
          />

          <SnLabel text={"특채수량"} type={"FreeForm"} />
          <SnNumberBox
            defaultValue={qt_qc_rcl}
            isRequired={true}
            isReadOnly={true}
          />
        </div>
        <div className="mb-4" style={{ textAlign: "center" }}></div>
        <div style={{ flex: 1, display: "flex", flexDirection: "column" }}>
          <SnGrid
            ref={gridRefs.current["grid1"]}
            columnConfig={grids.grid1.columns}
            rowData={grids.grid1.dataSource}
            etcProps={{
              isEditable: true,
              rowSelection: "single",
              popupParent: popupParent,
            }}
            events={grids.grid1.events}
          />
        </div>
      </div>
    );
  }
);

export default SN_QMS_CHEM_REG_001_POP_01;
